import React from "react";
import CreateUserForm from "../../components/forms/CreateUserForm";
import TwoColumnAuth from "../../components/layouts/TwoColumnAuth";

function SignUp() {
  return (
    <main className="auth-page">
      <TwoColumnAuth>
        <CreateUserForm />
      </TwoColumnAuth>
    </main>
  );
}

export default SignUp;